import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { style } from '@vanilla-extract/css';
import { navbarHeight } from '@/constants/styles-vars';
import { fullscreenPage } from '@/components/layout/fullscreen-page.css';

export const mainContentWrapper = style([
  {
    zIndex: -1,
    gridArea: 'main',
    width: '100%',
    height: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',

    containerType: 'inline-size',
  },
  responsiveStyle({
    mobile: {
      paddingBottom: navbarHeight,
      selectors: {
        [`&:has(> ${fullscreenPage}), [data-sidebar-hidden] > &`]: {
          paddingBottom: 0,
        },
      },
    },
    tablet: {
      paddingBottom: 0,
    },
  }),
]);
